"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemNewUserDTO = exports.SystemOrderCancelledDTO = exports.SystemOrderReversedDTO = exports.SystemOrderCreatedDTO = exports.SystemOrderFulfilledDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
const gal_reporting_groups_1 = require("../types/gal-reporting-groups");
let SystemOrderFulfilledDTO = class SystemOrderFulfilledDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SystemOrderFulfilledDTO, [gal_reporting_groups_1.GalReportingGroups.system]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "itemValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalUsd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "studio", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "category", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rarityLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raritySupplyLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "discountCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_ip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_agent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Applicable application'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "app", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Product name'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Order Id'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Product Id'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of product purchased'),
    __metadata("design:type", Number)
], SystemOrderFulfilledDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Currency used to purchase e.g. GALA'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Value of a single item in given currency'),
    __metadata("design:type", Number)
], SystemOrderFulfilledDTO.prototype, "itemValue", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value in given currency'),
    __metadata("design:type", Number)
], SystemOrderFulfilledDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value in USD at time of purchase'),
    __metadata("design:type", Number)
], SystemOrderFulfilledDTO.prototype, "totalUsd", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Studio name for the purchased item'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "studio", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Category for the purchased item'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Contract address for the purchased item'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "contractAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Rarity label/level for the purchased item'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "rarityLabel", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Supply limit for the rarity level of the item'),
    __metadata("design:type", Number)
], SystemOrderFulfilledDTO.prototype, "raritySupplyLimit", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Discount or promo code utilized, if any'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "discountCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('IP Address of user, if available'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "user_origin_ip", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User agent string of originating user, if available'),
    __metadata("design:type", String)
], SystemOrderFulfilledDTO.prototype, "user_origin_agent", void 0);
SystemOrderFulfilledDTO = __decorate([
    (0, decorators_1.Describe)('A system reported order fulfillment')
], SystemOrderFulfilledDTO);
exports.SystemOrderFulfilledDTO = SystemOrderFulfilledDTO;
let SystemOrderCreatedDTO = class SystemOrderCreatedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SystemOrderCreatedDTO, [gal_reporting_groups_1.GalReportingGroups.system]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "studio", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "category", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rarityLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raritySupplyLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "discountCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_ip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_agent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Applicable application'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "app", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Product name'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Order Id'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Product Id'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of product purchased'),
    __metadata("design:type", Number)
], SystemOrderCreatedDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Studio name for the purchased item'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "studio", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Category for the purchased item'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Contract address for the purchased item'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "contractAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Rarity label/level for the purchased item'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "rarityLabel", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Supply limit for the rarity level of the item'),
    __metadata("design:type", Number)
], SystemOrderCreatedDTO.prototype, "raritySupplyLimit", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Discount or promo code utilized, if any'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "discountCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('IP Address of user, if available'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "user_origin_ip", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User agent string of originating user, if available'),
    __metadata("design:type", String)
], SystemOrderCreatedDTO.prototype, "user_origin_agent", void 0);
SystemOrderCreatedDTO = __decorate([
    (0, decorators_1.Describe)('A system reported order was created, but not yet fulfilled')
], SystemOrderCreatedDTO);
exports.SystemOrderCreatedDTO = SystemOrderCreatedDTO;
let SystemOrderReversedDTO = class SystemOrderReversedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SystemOrderReversedDTO, [gal_reporting_groups_1.GalReportingGroups.system]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "itemValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalUsd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_ip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_agent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Reason for reversal of order'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Applicable application'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "app", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Product name'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Order Id'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Product Id'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of product purchased'),
    __metadata("design:type", Number)
], SystemOrderReversedDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Currency used to purchase e.g. GALA'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Value of a single item in given currency'),
    __metadata("design:type", Number)
], SystemOrderReversedDTO.prototype, "itemValue", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNegative)(),
    (0, decorators_1.Describe)('Total negative value in given currency'),
    __metadata("design:type", Number)
], SystemOrderReversedDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNegative)(),
    (0, decorators_1.Describe)('Total negative value in USD at time of purchase'),
    __metadata("design:type", Number)
], SystemOrderReversedDTO.prototype, "totalUsd", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('IP Address of user, if available'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "user_origin_ip", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User agent string of originating user, if available'),
    __metadata("design:type", String)
], SystemOrderReversedDTO.prototype, "user_origin_agent", void 0);
SystemOrderReversedDTO = __decorate([
    (0, decorators_1.Describe)('A system order was refunded or reversed after purchase')
], SystemOrderReversedDTO);
exports.SystemOrderReversedDTO = SystemOrderReversedDTO;
let SystemOrderCancelledDTO = class SystemOrderCancelledDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SystemOrderCancelledDTO, [gal_reporting_groups_1.GalReportingGroups.system]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_ip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_agent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Cancellation reason'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Applicable application'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "app", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Product name'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Order Id'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Gala Product Id'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of product purchased'),
    __metadata("design:type", Number)
], SystemOrderCancelledDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('IP Address of user, if available'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "user_origin_ip", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User agent string of originating user, if available'),
    __metadata("design:type", String)
], SystemOrderCancelledDTO.prototype, "user_origin_agent", void 0);
SystemOrderCancelledDTO = __decorate([
    (0, decorators_1.Describe)('A system reported order was cancelled prior to fulfillment')
], SystemOrderCancelledDTO);
exports.SystemOrderCancelledDTO = SystemOrderCancelledDTO;
let SystemNewUserDTO = class SystemNewUserDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SystemNewUserDTO, [
    gal_reporting_groups_1.GalReportingGroups.system,
]) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "role", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "language", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "referredBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communicationConsent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "testUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_ip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user_origin_agent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "role", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "language", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "referredBy", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Boolean)
], SystemNewUserDTO.prototype, "communicationConsent", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Boolean)
], SystemNewUserDTO.prototype, "testUser", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('IP Address of user, if available'),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "user_origin_ip", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User agent string of originating user, if available'),
    __metadata("design:type", String)
], SystemNewUserDTO.prototype, "user_origin_agent", void 0);
SystemNewUserDTO = __decorate([
    (0, decorators_1.Describe)('A new user reported by the system')
], SystemNewUserDTO);
exports.SystemNewUserDTO = SystemNewUserDTO;
